import { useState } from 'react';
import DOMPurify from 'dompurify';
import {
  GDPR_INTRO,
  GDPR_PHONE_INTRO_EXTRA,
  GDPR_DETAILS_NO_PHONE,
  GDPR_DETAILS_WITH_PHONE,
} from './gdprBoilerplate';

interface Props {
  hasPhone: boolean;
  obowiazekInformacyjny1?: string | null;
  obowiazekInformacyjny2?: string | null;
}

const sanitize = (html: string) => ({ __html: DOMPurify.sanitize(html) });

/**
 * Mirrors _form-info-container.twig's selection logic: a campaign-specific override
 * (obowiazekInformacyjny1/2) wins if BOTH are set, else falls back to the hardcoded
 * bilingual GDPR boilerplate (with/without the phone-specific paragraph).
 */
export default function GdprText({ hasPhone, obowiazekInformacyjny1, obowiazekInformacyjny2 }: Props) {
  const [expanded, setExpanded] = useState(false);
  const hasOverride = !!obowiazekInformacyjny1 && !!obowiazekInformacyjny2;

  const intro = hasOverride
    ? obowiazekInformacyjny1!
    : hasPhone
    ? GDPR_INTRO + GDPR_PHONE_INTRO_EXTRA
    : GDPR_INTRO;
  const details = hasOverride ? obowiazekInformacyjny2! : hasPhone ? GDPR_DETAILS_WITH_PHONE : GDPR_DETAILS_NO_PHONE;

  return (
    <div className="form-info-container">
      <div className="form-info">
        <div dangerouslySetInnerHTML={sanitize(intro)} />
        <a
          href="#!"
          className="more-info more-info-link js-btn-more-info"
          onClick={(e) => {
            e.preventDefault();
            setExpanded((v) => !v);
          }}
        >
          Zobacz więcej
        </a>
        <div className={`more-info js-more-info${expanded ? '' : ' is-hidden'}`}>
          <div dangerouslySetInnerHTML={sanitize(details)} />
          <p>
            <a
              href="#!"
              onClick={(e) => {
                e.preventDefault();
                setExpanded(false);
              }}
            >
              Zwiń
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
